import { Stack, Typography, Select, Input, styled } from '@mui/material';

import { ThemeColorScheme } from '@common/hooks/use-theme-mode.hook';

const UserSelectTenantInput = styled(Input)(({ theme }) => ({
  ...theme.typography.caption,
}));

interface UserSettingsThemeSwitcherProps {
  value: string;
  onChange: (val: ThemeColorScheme) => void;
}

export default function UserThemeSwitcher({ value, onChange }: UserSettingsThemeSwitcherProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="caption">Theme</Typography>
      <Select
        disableUnderline
        input={<UserSelectTenantInput />}
        value={value}
        onChange={(e) => {
          onChange(e.target.value as ThemeColorScheme);
        }}
        native
      >
        <option value={ThemeColorScheme.system}>System</option>
        <option value={ThemeColorScheme.dark}>Dark</option>
        <option value={ThemeColorScheme.light}>Light</option>
      </Select>
    </Stack>
  );
}
